// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import UserProfile from "./user/profile";
import Agents from "./agents";
import AgentGroups from "./agents/groups";
import WalletPage from "./wallet";
import Users from "./users";
import AccountProfile from "./account";
import Trainings from "./trainings";
import BillingPage from "./billing";
import AttendancesPage from "./attendances";
import AgentBenefitsPage from "./agent_benefits";
import VoiceNumbersPage from "./voice/numbers";
import CallCentersPage from "./voice/call_center/call_centers";
import BusinessLinesPage from "./voice/business_line";

const routes = [
  {
    type: "group",
    title: "Voice Center",
    icon: "dialer_sip",
  },
  {
    type: "collapse",
    name: "Phone Numbers",
    key: "voice",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/voice-os",
    component: <VoiceNumbersPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Call Centers",
    key: "voice/call-centers",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/voice/call-centers",
    component: <CallCentersPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Staff Numbers",
    key: "voice/business-lines",
    icon: <Icon fontSize="small">phone</Icon>,
    route: "/voice/business-lines",
    component: <BusinessLinesPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Team Management",
    icon: "people",
  },
  {
    type: "collapse",
    name: "Agents",
    key: "agents",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/agents",
    component: <Agents />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Agent Groups",
    key: "agent-groups",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/agent-groups",
    component: <AgentGroups />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "trainings",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/trainings",
    component: <Trainings />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Attendance Trackers",
    key: "attendances",
    icon: <Icon fontSize="small">recent_actors</Icon>,
    route: "/attendances",
    component: <AttendancesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Benefits",
    key: "agent-benefits",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/agent-benefits",
    component: <AgentBenefitsPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Accounts & Billing",
    icon: "domain",
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/billing",
    component: <BillingPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet",
    component: <WalletPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/account",
    component: <AccountProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Users />,
    secure: true,
  },

  {
    type: "divider",
    name: "Divider",
  },
];

export default routes;
